<template lang="pug">
  Icon.icon(name="notification-lightning" v-if="type === 'icon'")
  div(v-else-if="type === 'title'") Напоминание о задаче
    Link(:to="{ name: 'task-detail', params: item.info }")  {{ item.info.taskName }}
    |  в проекте
    Link(:to="{ name: 'project-stages', params: item.info }")  {{ item.info.projectName }}
</template>

<script>
export default {
  name: 'NotificationTaskReminder',
  props: {
    item: Object,
    type: String,
  },
};
</script>

<style scoped>

</style>
